import React, { useEffect, useState } from 'react';
import classes from './ProductCharacteristics.module.css';
import { Box, NumberInput, Paper, Select, SimpleGrid, Space, Text, TextInput } from '@mantine/core';
import { useParams } from 'react-router-dom';
import { IoAddOutline, IoTrashOutline } from "react-icons/io5";
import { baseUrl } from '../../../../../Constants/constant';
import useFetch from '../../../../../Customhooks/useFetch';

interface FormField {
    id_comp: number;
    id: number | null;
    vertical_id: string | null;
    category_id: string | null;
    material_name: string | null;
    materialSub_type_name: string | null;
    water_consumption: string;
    weight: string;
    percentage: string;
    gsm_size: string;
    sheet_size_height: string;
    sheet_size_width: string;
    no_of_product: string;
    // no_of_layers: string;
    // glue_Co2: string;
    // coverage: string;
    // ink_co2: string;
    weight_type: string;
}

interface SelectOption {
    value: string;
    label: string;
}
interface ProductCharacteristicsProps {
    onFieldsChange: (fields: FormField[]) => void;
    onValidationChange: (isValid: boolean) => void;
    showErrors: boolean;
    initialFields?: FormField[];
}

const ProductCharacteristics: React.FC<ProductCharacteristicsProps> = ({
    onFieldsChange,
    onValidationChange,
    showErrors,
    initialFields,

}) => {
    const [verticals, setVerticals] = useState<SelectOption[]>([]);
    const [rawMaterial, setRawMaterial] = useState<SelectOption[]>([]);
    const [materialSub, setMaterialSub] = useState<SelectOption[]>([]);
    const [subTypeDetails, setSubTypeDetails] = useState<Record<string, any>>({});
    const [category, setCategory] = useState<SelectOption[]>([]);
    const [errors, setErrors] = useState<Record<string, string>>({});
    const [fields, setFields] = useState<FormField[]>([{
        id_comp: 1,
        // country: null,
        id: null,
        vertical_id: null,
        category_id: null,
        material_name: null,
        materialSub_type_name: null,
        water_consumption: "",
        weight: "",
        percentage: "",
        gsm_size: "",
        sheet_size_height: "",
        sheet_size_width: "",
        no_of_product: "",
        // no_of_layers: "",
        // glue_Co2: "",
        // coverage: "",
        // ink_co2: "",
        weight_type: "",
    }]);

    const { id } = useParams();
    const token = localStorage.getItem("token");

    const fetchConfig = {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            "Access-Control-Allow-Origin": "*",
            token: token,
        },
    };

    const { data: getData, fetchData: getCountries } = useFetch(fetchConfig);
    const { data: getVerticalData, fetchData: getVerticals } = useFetch(fetchConfig);
    const { data: getRawMaterialData, fetchData: getRawMaterial } = useFetch(fetchConfig);
    const { data: getMaterialSubTypeData, fetchData: getMaterialSubType } = useFetch(fetchConfig);
    const { data: getCategoryData, fetchData: getCategory } = useFetch(fetchConfig);

    useEffect(() => {
        onFieldsChange(fields);
        const isValid = validateFields();
        onValidationChange(isValid);
    }, [fields]);

    useEffect(() => {
        getCountries(`${baseUrl}admin/countries`);
        getVerticals(`${baseUrl}admin/verticals`);
    }, []);


    useEffect(() => {
        if (getVerticalData?.data?.rows) {
            const verticalOptions = getVerticalData.data.rows.map((el: any) => ({
                value: el.vertical_id.toString(),
                label: el.vertical_name,
            }));
            setVerticals(verticalOptions);
        }
    }, [getVerticalData]);
    useEffect(() => {
        if (getRawMaterialData?.data?.rows) {
            setRawMaterial(getRawMaterialData.data.rows.map((el: any) => ({
                value: el.id.toString(),
                label: el.material_name,
            })));
        }
    }, [getRawMaterialData]);

    useEffect(() => {
        if (getMaterialSubTypeData?.data?.rows) {
            setMaterialSub(getMaterialSubTypeData.data.rows.map((el: any) => ({
                value: el.id.toString(),
                label: el.sub_name,
            })));
            const SubTypeDetailsMap = getMaterialSubTypeData.data.rows.reduce((acc: Record<string, any>, el: any) => {
                acc[el.id.toString()] = el;
                return acc;
            }, {});
            setSubTypeDetails(SubTypeDetailsMap);
        }
    }, [getMaterialSubTypeData]);

    useEffect(() => {
        if (getCategoryData?.data?.rows) {
            setCategory(getCategoryData.data.rows.map((el: any) => ({
                value: el.category_id.toString(),
                label: el.category_name,
            })));
        }
    }, [getCategoryData]);



    useEffect(() => {
        if (initialFields && initialFields.length > 0) {
            const updatedFields = initialFields.map(field => ({
                ...field,
                vertical_id: field.vertical_id?.toString() || null,
                category_id: field.category_id?.toString() || null,
                material_name: field.material_name?.toString() || null,
                materialSub_type_name: field.materialSub_type_name?.toString() || null,
                water_consumption: field.water_consumption?.toString() || "",
                weight: field.weight?.toString() || "",
                percentage: field.percentage?.toString() || ""
            }));
            setFields(updatedFields);

            // Fetch dependent data for each field
            initialFields.forEach(field => {
                if (field.vertical_id) {
                    getRawMaterial(`${baseUrl}admin/raw-materials`);
                    getCategory(`${baseUrl}admin/categories`);
                    // getRawMaterial(`${baseUrl}admin/raw-materials?vertical_id=${field.vertical_id}`);
                    // getCategory(`${baseUrl}admin/categories?vertical_id=${field.vertical_id}`);
                }
                if (field.material_name) {
                    // getMaterialSubType(`${baseUrl}admin/raw-material-sub-types?material_id=${field.material_name}`);
                    getMaterialSubType(`${baseUrl}admin/raw-material-sub-types`);
                }
            });
        }
    }, [initialFields]);




    const validateFields = () => {
        const newErrors: Record<string, string> = {};
        let isValid = true;

        fields.forEach((field, index) => {
            // Required field validations
            // if (!field.country) {
            //     newErrors[`country_${index}`] = "Country is required";
            //     isValid = false;
            // }
            if (!field.vertical_id) {
                newErrors[`vertical_id_${index}`] = "Vertical is required";
                isValid = false;
            }
            if (!field.category_id) {
                newErrors[`category_id_${index}`] = "Category is required";
                isValid = false;
            }
            if (!field.material_name) {
                newErrors[`material_name_${index}`] = "Material is required";
                isValid = false;
            }
            if (!field.materialSub_type_name) {
                newErrors[`materialSub_type_name_${index}`] = "Sub-type is required";
                isValid = false;
            }

            // Numeric field validations
            if (!field.water_consumption) {
                newErrors[`water_consumption_${index}`] = "Water consumption is required";
                isValid = false;
            } else if (isNaN(Number(field.water_consumption))) {
                newErrors[`water_consumption_${index}`] = "Must be a valid number";
                isValid = false;
            }

            // if (!field.weight) {
            //     newErrors[`weight_${index}`] = "Weight is required";
            //     isValid = false;
            // } else if (isNaN(Number(field.weight))) {
            //     newErrors[`weight_${index}`] = "Must be a valid number";
            //     isValid = false;
            // }

            // if (!field.percentage) {
            //     newErrors[`percentage_${index}`] = "Percentage is required";
            //     isValid = false;
            // } else {
            //     const percentageValue = Number(field.percentage);
            //     if (isNaN(percentageValue)) {
            //         newErrors[`percentage_${index}`] = "Must be a valid number";
            //         isValid = false;
            //     } else if (percentageValue < 0 || percentageValue > 100) {
            //         newErrors[`percentage_${index}`] = "Percentage must be between 0 and 100";
            //         isValid = false;
            //     }
            // }
        });

        setErrors(newErrors);
        onValidationChange(isValid);
        return isValid;
    };


    const handleChange = (index: number, field: keyof FormField, value: string | null | number) => {
        setFields(prev => {
            const newFields = [...prev];

            // Update the current field value
            newFields[index] = {
                ...newFields[index],
                [field]: value
            };

            // Handle dependent fields reset based on which field changed
            if (field === 'vertical_id') {
                newFields[index] = {
                    ...newFields[index],
                    material_name: null,
                    materialSub_type_name: null,
                    category_id: null
                };

                // Fetch dependent data if value exists
                if (value) {
                    getRawMaterial(`${baseUrl}admin/raw-materials?vertical_id=${value}`);
                    getCategory(`${baseUrl}admin/categories?vertical_id=${value}`);
                }
            } else if (field === 'material_name') {
                newFields[index] = {
                    ...newFields[index],
                    materialSub_type_name: null
                };

                // Fetch dependent data if value exists
                if (value) {
                    getMaterialSubType(`${baseUrl}admin/raw-material-sub-types?material_id=${value}`);
                }
            }
            if (field === 'materialSub_type_name' && value) {
                const selectedSubType = subTypeDetails[value];
                if (selectedSubType) {
                    newFields[index].weight_type = selectedSubType?.Weighttype?.weight_name || "";
                }
            }

            return newFields;
        });
    };
    useEffect(() => {
        onFieldsChange(fields);
        if (showErrors) {
            validateFields();
        }
    }, [fields, showErrors]);

    const addComponent = () => {
        // Reset all errors
        setErrors({});
        // Reset show errors state in parent component if needed
        if (onValidationChange) {
            onValidationChange(true);
        }

        // Add new component
        setFields(prev => [...prev, {
            id_comp: prev.length + 1,
            // country: null,
            id: null,
            vertical_id: null,
            category_id: null,
            material_name: null,
            materialSub_type_name: null,
            water_consumption: "",
            weight: "",
            percentage: "",
            gsm_size: "",
            sheet_size_height: "",
            sheet_size_width: "",
            no_of_product: "",
            // no_of_layers: "",
            // glue_Co2: "",
            // coverage: "",
            // ink_co2: "",
            weight_type: "",
        }]);
    };
    const handledeletecomponent = (id_comp: any) => {
        setFields(prev => prev.filter(field => field.id_comp !== id_comp));
    };

    return (
        <div>
            {fields.map((field, index) => (
                <Paper className={classes.productdiv} key={field.id_comp} shadow="xs" p="xs" radius="md" mb={10}>
                    <Space />
                    {fields.length > 1 && <Box className={classes.delete_box} ><IoTrashOutline fill='red' size={20} onClick={() => handledeletecomponent(field.id_comp)} /></Box>}
                    <Box ml={5}>
                        <SimpleGrid cols={4}>
                            <Select
                                label="Select Verticals"
                                withAsterisk
                                placeholder="Choose Verticals"
                                data={verticals}
                                variant="filled"
                                searchable
                                radius={6}
                                maxDropdownHeight={200}
                                value={field.vertical_id}
                                onChange={(value) => handleChange(index, "vertical_id", value)}
                                error={showErrors ? errors[`vertical_id_${index}`] : null}
                            />
                            <Select
                                label="Select Category"
                                withAsterisk
                                variant="filled"
                                placeholder="Select Category"
                                data={category}
                                searchable
                                maxDropdownHeight={200}
                                value={field.category_id}
                                onChange={(value) => handleChange(index, "category_id", value)}
                                disabled={!field.vertical_id}
                                radius={6}
                                error={showErrors ? errors[`category_id_${index}`] : null}
                            />
                            <Select
                                label="Select Raw Materials"
                                withAsterisk
                                variant="filled"
                                placeholder="Select Raw Material"
                                data={rawMaterial}
                                searchable
                                maxDropdownHeight={200}
                                value={field.material_name}
                                onChange={(value) => handleChange(index, "material_name", value)}
                                disabled={!field.vertical_id}
                                radius={6}
                                error={showErrors ? errors[`material_name_${index}`] : null}
                            />
                            <Select
                                label="Select Material Sub Type"
                                withAsterisk
                                variant="filled"
                                placeholder="Select Material Sub Type"
                                data={materialSub}
                                searchable
                                maxDropdownHeight={200}
                                value={field.materialSub_type_name}
                                onChange={(value) => handleChange(index, "materialSub_type_name", value)}
                                disabled={!field.material_name}
                                radius={6}
                                error={showErrors ? errors[`materialSub_type_name_${index}`] : null}
                            />
                            <TextInput
                                label="Water consumption (liters)"
                                withAsterisk
                                placeholder="Water consumption"
                                variant="filled"
                                value={field.water_consumption}
                                onChange={(e) => handleChange(index, "water_consumption", e.target.value)}
                                error={showErrors ? errors[`water_consumption_${index}`] : null}
                            />
                            {field.weight_type === "WEIGHT" && <> <NumberInput
                                label="Weight (g)"
                                withAsterisk
                                placeholder="Weight"
                                hideControls
                                variant="filled"
                                value={field.weight}
                                onChange={(value) => handleChange(index, "weight", value)}
                                error={showErrors ? errors[`weight_${index}`] : null}
                            />
                                <NumberInput
                                    label="Percentage (%)"
                                    withAsterisk
                                    placeholder="Percentage"
                                    hideControls
                                    variant="filled"
                                    value={field.percentage}
                                    onChange={(value) => handleChange(index, "percentage", value)}
                                    error={showErrors ? errors[`percentage_${index}`] : null}
                                />
                            </>
                            }

                            <TextInput
                                value={field.id_comp}
                                onChange={(e) => handleChange(index, "id", e.target.value)}
                                style={{ display: 'none' }}
                            />
                            {field.weight_type === "GSM" && <>
                                <NumberInput
                                    label="GSM size"
                                    withAsterisk
                                    placeholder="Enter Gsm size"
                                    hideControls
                                    variant="filled"
                                    name='gsm_size'
                                    value={field?.gsm_size || ''}
                                    onChange={(value) => handleChange(index, "gsm_size", value)}
                                    error={showErrors ? errors[`gsm_size${index}`] : null}
                                />
                                <NumberInput
                                    label="Sheet Height (mm)"
                                    withAsterisk
                                    placeholder="Enter Sheet size"
                                    hideControls
                                    variant="filled"
                                    value={field?.sheet_size_height || ''}
                                    onChange={(value) => handleChange(index, "sheet_size_height", value)}
                                    error={showErrors ? errors[`sheet_size_height${index}`] : null}
                                />
                                <NumberInput
                                    label="Sheet width (mm)"
                                    withAsterisk
                                    placeholder="Enter Sheet size"
                                    hideControls
                                    variant="filled"
                                    value={field?.sheet_size_width || ''}
                                    onChange={(value) => handleChange(index, "sheet_size_width", value)}
                                    error={showErrors ? errors[`sheet_size_width${index}`] : null}
                                />
                                <NumberInput
                                    label="Number of Products"
                                    withAsterisk
                                    placeholder="Enter Number of Products"
                                    hideControls
                                    variant="filled"
                                    value={field?.no_of_product || ''}
                                    onChange={(value) => handleChange(index, "no_of_product", value)}
                                    error={showErrors ? errors[`no_of_product${index}`] : null}
                                />
                                {/* <NumberInput
                                    label="No of layers"
                                    withAsterisk
                                    placeholder="Enter no of layers"
                                    hideControls
                                    variant="filled"
                                    value={field?.no_of_layers || ''}
                                    onChange={(value) => handleChange(index, "no_of_layers", value)}
                                    error={showErrors ? errors[`no_of_layers${index}`] : null}
                                />
                                <NumberInput
                                    label="Glue Type Co2 per cm"
                                    withAsterisk
                                    placeholder="Enter Co2 per cm"
                                    hideControls
                                    variant="filled"
                                    value={field?.glue_Co2 || ''}
                                    onChange={(value) => handleChange(index, "glue_Co2", value)}
                                    error={showErrors ? errors[`glue_Co2${index}`] : null}
                                />
                                <NumberInput
                                    label="Coverage %"
                                    withAsterisk
                                    placeholder="Enter Sheet size"
                                    hideControls
                                    variant="filled"
                                    value={field?.coverage || ''}
                                    onChange={(value) => handleChange(index, "coverage", value)}
                                    error={showErrors ? errors[`coverage${index}`] : null}
                                />
                                <NumberInput
                                    label="Ink Type Co2 per cm"
                                    withAsterisk
                                    placeholder="Enter Number of Products"
                                    hideControls
                                    variant="filled"
                                    value={field?.ink_co2 || ''}
                                    onChange={(value) => handleChange(index, "ink_co2", value)}
                                    error={showErrors ? errors[`ink_co2${index}`] : null}
                                /> */}
                            </>}
                        </SimpleGrid>
                    </Box>
                    <Space h="sm" />
                </Paper>
            ))}
            <Box className={classes.addmoreleg}>
                <span style={{ display: 'flex' }}><IoAddOutline size={18} /></span>
                <Text
                    variant="default"
                    onClick={addComponent}
                    ta="right"
                    pl={4}
                >
                    Add More Component
                </Text>
            </Box>
        </div>
    );
};

export default ProductCharacteristics;